import React from 'react';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import InternetJsxRenderer from './InternetJsxRenderer';
export const ExtraCard = (props) => {
    const { slug } = props;
    const { internetCalculatorExtraCardsState, secureNetCalculatorExtraCardsState, isSecureNet } = useInternetCalculator();
    const extraCard = (isSecureNet ? secureNetCalculatorExtraCardsState : internetCalculatorExtraCardsState).extraCards.find((o) => o.slug === slug);
    if (!(extraCard === null || extraCard === void 0 ? void 0 : extraCard.content)) {
        return null;
    }
    return React.createElement(InternetJsxRenderer, { jsx: extraCard.content });
};
